<div class="main-wrapper">
  <div class="container">
    <div class="apostrophe">
      <div class="heading text-center">
        {{section?.header}}
      </div>
      <div class="divider"></div>
      <div class="sub-heading text-center">
        {{section?.sub_header}}
      </div>
    </div>
    <div class="card-wrapper">
      <ngx-glide [showArrows]="true" [showBullets]="false" [perView]="1" [bound]="true" [gap]="15" arrowLeftLabel="" arrowRightLabel="">
        <div class="testimonial-wrapper" *ngFor="let item of section?.data_images">
          <div class="quotation-mark">
            <img src="/assets/images/medical-landing/right-quotation-mark.png" alt="Quotation Mark">
          </div>
          <div class="details">
            <div class="desc">
              “{{item?.text}}”
            </div>
            <div class="{{item?.profile}}"></div>
            <div class="name">
              {{item?.title}}
            </div>
            <div class="designation">
              {{item?.desc}}
            </div>
          </div>
        </div>
      </ngx-glide>
    </div>
  </div>
</div>
